import { ReactComponent as ExternalLinkIcon } from 'assets/external-link.svg';
import PodcastDestinationLink from 'components/PodcastDestinationLink';
import styles from './NewsweekContinueListeningLink.module.scss';

const NewsweekContinueListeningLink: React.FC = () => (
  <PodcastDestinationLink className={styles.link}>
    <div className={styles.iconContainer}>
      <ExternalLinkIcon height="20px" width="20px" />
    </div>
    <div className={styles.text}>continue listening</div>
  </PodcastDestinationLink>
);

export default NewsweekContinueListeningLink;
